document.documentElement.classList.remove('no-js');
document.addEventListener('click', function(e){
  const trigger=e.target.closest('[data-accordion-trigger]');
  if(!trigger) return;
  const item=trigger.closest('[data-accordion-item]');
  if(!item) return;
  const body=item.querySelector('[data-accordion-body]');
  const open=item.getAttribute('data-open')==='true';
  item.setAttribute('data-open', open ? 'false':'true');
  trigger.setAttribute('aria-expanded', open ? 'false':'true');
  body.hidden=open;
});

document.addEventListener('click', function(e){
  const closeButton = e.target.closest('[data-mobile-menu-close]');
  if(closeButton){
    const details = closeButton.closest('.ct-mobile-menu');
    if(details) details.removeAttribute('open');
    return;
  }

  const mobileLink = e.target.closest('.ct-mobile-drawer__nav a');
  if(mobileLink){
    const details = mobileLink.closest('.ct-mobile-menu');
    if(details) details.removeAttribute('open');
  }
});
